module.exports = __webpack_public_path__ + "media/images/payments/visa-2c80051eb4ed6fc1538f3eed46469913.svg";